import React from "react";
import { NavLink } from "react-router-dom";
import "../styles.css";
import resume from "./resources/documentdownload.png";
import hamburgerIcon from "./resources/hambergermenu.png";

function Header() {
    return (
        <header>
            <img src={hamburgerIcon} className="hamburger" alt="dropdown-menu" />
            <ul className="navlist">
                <li className="navlink menu_heading">MENU</li>
                <li className="navlink"><NavLink
                    className={({ isActive }) => (isActive ? "link-active" : "link")}
                    to="/">
                  Hello
                </NavLink><span className="sr-only">(current)</span></li>
                <li className="navlink"><NavLink
                    className={({ isActive }) => (isActive ? "link-active" : "link")}
                    to="/lab">
                  Lab
                </NavLink></li>
                <li className="navlink"><NavLink
                    className={({ isActive }) => (isActive ? "link-active" : "link")}
                    to="/contact">
                  Contact
                </NavLink></li>
                <li className="navlink"><a className="resume_icon" href={require("./resources/Resume-Leah-2025.pdf")} download><img src={resume} className="resume_icon_img" alt="" /></a></li>
            </ul>
            <div className="nav_right">
                <h2 className="nav_icon">LEAH PATHAN KHAN</h2>
            </div>
        </header>
    );
};

export default Header;